import { cva } from 'class-variance-authority';

/**
 * Variantes do botão, em arquivo próprio para não quebrar o fast refresh
 * (um módulo de componente deve exportar só componentes).
 */
export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors disabled:pointer-events-none disabled:opacity-50 [&_svg]:size-4 [&_svg]:shrink-0 whitespace-nowrap',
  {
    variants: {
      variant: {
        primary: 'bg-(--color-brand) text-(--color-brand-contrast) hover:opacity-90',
        secondary:
          'bg-(--color-surface-muted) text-(--color-content) border border-(--color-border-subtle) hover:bg-(--color-surface-raised)',
        ghost: 'text-(--color-content) hover:bg-(--color-surface-muted)',
        danger: 'bg-(--color-state-danger) text-white hover:opacity-90',
        link: 'text-(--color-brand) underline-offset-4 hover:underline',
      },
      size: {
        /*
         * No dedo, 44px; no ponteiro, o tamanho compacto de sempre.
         *
         * A altura maior é a **base**, e o `md:` é que encolhe — não o contrário. Um
         * botão novo escrito daqui a seis meses nasce tocável por omissão, e esquecer o
         * `md:` produz um botão grande no monitor, que é o erro barato dos dois.
         */
        sm: 'h-11 px-3 md:h-8',
        md: 'h-11 px-4 md:h-9',
        lg: 'h-11 px-6 text-base',
        touch: 'h-12 px-6 text-base',
        icon: 'size-11 md:size-9',
      },
    },
    defaultVariants: { variant: 'secondary', size: 'md' },
  },
);
